module.exports = __webpack_public_path__ + "img/alerts.de4da4b0.png";